'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agentTypingMessageReceived = undefined;

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _typingStateConstants = require('../constants/typingStateConstants');

var _addTypingTimeoutIdForAgentInThread = require('./addTypingTimeoutIdForAgentInThread');

var _dismissAgentTypingIndicator = require('./dismissAgentTypingIndicator');

var _clearExistingAgentTypingTimeout = require('./clearExistingAgentTypingTimeout');

var agentTypingMessageReceived = exports.agentTypingMessageReceived = function agentTypingMessageReceived(message, threadId) {
  return function (dispatch) {
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _clearExistingAgentTypingTimeout.clearExistingAgentTypingTimeout)(message, threadId));

    var timeoutId = setTimeout(function () {
      dispatch((0, _dismissAgentTypingIndicator.dismissAgentTypingIndicator)(message, threadId));
    }, _typingStateConstants.TYPING_INDICATOR_TIMEOUT_MS);

    dispatch((0, _addTypingTimeoutIdForAgentInThread.addTypingTimeoutIdForAgentInThread)(threadId, senderId, timeoutId));
  };
};